import { Box, Button, Typography } from '@material-ui/core';

import { SaturationIcon } from '../saturation-icon';
import { ChipDisclaimer } from '../chip-disclaimer';
import { useDemandStatusOptionTexts } from './useDemandStatusOptionTexts';
import makeClasses from './DemandStatusOption.style';

import type { ReactNode } from 'react';
import type { SaturationStateProp } from '../../shared/models';
import type { Saturation } from '../../../../business/highDemand';

export function DemandStatusOption(props: Props) {
  const {
    children = null,
    variant,
    onSelect,
    name = '',
    extraTime = 0,
    disabled = false,
    selected = false,
    isEligibleForFastOperation = true,
    severity
  } = props;

  const classes = makeClasses({ selected, variant });
  const texts = useDemandStatusOptionTexts({ variant, extraTime });
  const isHidden = (variant === 'low' && isEligibleForFastOperation)
    || (variant === 'low' && severity === 'high')
    || (variant === 'high' && severity === 'low')

  if (isHidden) return null

  return (
    <Button
      name={name}
      role='option'
      variant='contained'
      disabled={disabled}
      aria-selected={selected}
      onClick={() => onSelect?.(variant)}
      classes={{ contained: classes.option, label: classes.optionLabel }}
    >
      <section className={classes.sectionMain}>
        <Box
          component='aside'
          className={classes.aside}
          aria-disabled={disabled}
        >
          <SaturationIcon size='medium' variant={variant} />
        </Box>
        <Box component='main' className={classes.main}>
          <Box display='flex' alignItems='center' gridGap='0.5rem'>
            <Typography
              variant='h1'
              aria-disabled={disabled}
              className={classes.title}
            >
              {texts.title}
            </Typography>
            {texts.disclaimer && (
              <ChipDisclaimer 
                variant={variant} 
                disclaimer={texts.disclaimer}
                disabled={disabled} 
              />
            )}
          </Box>
          <Typography
            aria-disabled={disabled}
            className={classes.legend}
            dangerouslySetInnerHTML={{ __html: texts.legend }}
          />
        </Box>
      </section>
      {children}
    </Button>
  );
}

interface Props extends SaturationStateProp {
  children?: ReactNode;
  variant: Saturation;
  name?: string;
  extraTime?: number;
  disabled?: boolean;
  selected?: boolean;
  onSelect?: (v: Saturation) => void;
  isEligibleForFastOperation?: boolean;
  severity: any;
}
